import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import { useLocale } from "@insightfulscience/i18";

const Error404 = () => {
	const [t] = useLocale("404");

	return (
		<>
			<Heading
				Tag="h1"
				sx={{ fontSize: "xl", fontColor: "3", textAlign: "center" }}
				spacing={{ mb: 6 }}
			>
				{t("NOT_FOUND")}
			</Heading>
			<Paragraph sx={{ fontSize: "s", textAlign: "center" }}>{t("DESC")}</Paragraph>
		</>
	);
};

export default Error404;
